const Logan = Mach.requireModule('Logan');
function logan(logData) {
  if (Logan) {
    try {
      const logStr = JSON.stringify(logData);
      if (logStr) {
        Logan.log(logStr);
      }
    } catch (error) {}
  }
}

export { logan };
